<template>
  <modal v-if="isShow" @close="$emit('update:isShow', false)">
        
    <template slot="header">
      <md-button class="md-info md-sm" @click="exportToPDF">PDF로 저장</md-button>
      <md-button class="md-default md-sm" @click="$emit('update:isShow', false)">닫기</md-button>
    </template>
    <template slot="body">
<div  ref="pdfArea" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">   
  
<div ref="dummySelfIntro" style="visibility:hidden;position:absolute;font-size:9pt;letter-spacing:0;line-height:150%;top:0;width:515px;white-space:pre-wrap;word-break:normal;text-align:left;">
    {{ dummyLines[0] }}
</div>   
  <div class="wrap" style="width: 595px; padding: 30px; background: #fff;">    
      <div style="height: 38px; display: flex; justify-content: center; align-items: center; gap: 10px;">
        <p style="width: 38px;">
          <img src="/img/kuaa_logo_wh.png" alt="" style="width: 100%;">
        </p>

        <div style="color: #000; font-size: 18px; font-weight: 700;">
          고대교우회/(재)고우장학회 장학생 신청서
        </div>
      </div>

      <div style="border: 1px solid #000; display: flex; margin-top: 10px;">
        <ul style="background: #e0e0e0; width: 99px; font-weight: 500;">
          <li style="height: 20px; display: flex; justify-content:left; align-items: center;background: #fff;">
            <p style="margin-left: 0px; height: 20px;  border-right: 1px solid #000; width: 50px; display: flex; justify-content: center; align-items: center; background: #e0e0e0;">접수번호</p>
          </li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000; background: #e0e0e0;">대학(학부)</li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000; background: #e0e0e0;">학과(학부)</li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000; background: #e0e0e0;">학년</li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000; background: #e0e0e0;">학번</li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000; background: #e0e0e0;">성명</li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000; background: #e0e0e0;">생년월일</li>
          <li style="height: 20px; display: flex; justify-content:center; align-items: center; border-top: 1px solid #000;">총 이수 학기</li>
        </ul>
        <ul style="width: 305px; border-left: 1px solid #000;">
          <li style="height: 20px; display: flex; align-items: center; padding-left: 0px;">
            <p style="margin-left: 0px; height: 20px;  border-right: 1px solid #000; width: 80px; display: flex; justify-content: center; align-items: center; background: #e0e0e0;font-weight: 500; margin-right: 25px;">신청대상 장학금</p>
            <p
                :style="{
                  width: '10px',
                  height: '10px',
                  border: '1px solid #000',
                  background: printData.applyGb === '1' ? '#000' : '#fff',
                  marginRight: '2px',
                  marginLeft: '10px'
                }"
              ></p>
              <p :style="{ fontWeight: printData.applyGb === '1' ? 'bold' : 'normal' }">개인명의 장학생</p>
              <p
                :style="{
                  width: '10px',
                  height: '10px',
                  border: '1px solid #000',
                  background: printData.applyGb === '2' ? '#000' : '#fff',
                  margin: '0 2px 0 14px'
                }"
              ></p>
              <p :style="{ fontWeight: printData.applyGb === '2' ? 'bold' : 'normal' }">교우자녀 장학생</p>
            
          </li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; padding-left: 10px; align-items: center;">{{printData.collegeMCdNm}}</li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; padding-left: 10px; align-items: center;">{{printData.collegeSCdNm}}</li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; padding-left: 10px; align-items: center;">{{printData.collegeSemesterCdNm}}</li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; padding-left: 10px; align-items: center;">{{printData.hakbun}}</li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; padding-left: 10px; align-items: center;">{{printData.nm}}</li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; align-items: center;">
            <p style="width: 166px; display: flex; gap: 24px; padding-left: 10px;">
                <span>{{ printData.bornYm ? printData.bornYm.slice(0,4) : '' }} 년</span>
                <span>{{ printData.bornYm ? printData.bornYm.slice(4,6) : '' }} 월</span>
                <span>{{ printData.bornYm ? printData.bornYm.slice(6,8) : '' }} 일</span>
            </p>
            <div style="border-left: 0px solid #000; height: 100%; display: flex; justify-content: center; align-items: center; gap: 6px;">
              <p style="margin-left: 0px; height: 19px;  border-right: 1px solid #000; border-left: 1px solid #000;width: 50px; display: flex; justify-content: center; align-items: center; background: #e0e0e0;">성별</p>
              <p
                :style="{
                  width: '10px',
                  height: '10px',
                  border: '1px solid #000',
                  background: printData.sex === 'M' ? '#000' : '#fff',
                  marginRight: '2px'
                }"
              ></p>
              <p :style="{ fontWeight: printData.sex === 'M' ? 'bold' : 'normal' }">남</p>
              <p
                :style="{
                  width: '10px',
                  height: '10px',
                  border: '1px solid #000',
                  background: printData.sex === 'F' ? '#000' : '#fff',
                  margin: '0 2px 0 4px'
                }"
              ></p>
                <p :style="{ fontWeight: printData.sex === 'F' ? 'bold' : 'normal' }">여</p>

            </div>
          </li>
          <li style="border-top: 1px solid #000; height: 20px; display: flex; align-items: center; padding-left: 10px; color: #000;">
            {{printData.completeSemester}} 학기
          </li>
        </ul>
        <div style="flex: 1 1 auto; border-left: 1px solid #000; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px;">
          <img :src="downloadUrl + '?orgFileName=신청서사진&fileFullPathName=' + printData.picDir" style="max-width: 120px; max-height: 120px; width: auto; height: auto;">
        </div>
      </div>

      <div style="display: flex; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500;">
          성적사항
        </p>


        <ul style="border-left: 1px solid #000; flex: 1 1 auto;">
          <li style="display: flex; height: 20px; background: #e0e0e0; font-weight: 500;">
            <p style="display: flex; justify-content: center; align-items: center; width: 72px;">총 이수 학점</p>
            <p style="display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; width: 72px;">평균 평점</p>
            <p style="display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; flex: 1 1 auto;">직전2학기</p>
          </li>

          <li style="display: flex; height: 20px; border-top: 1px solid #000;">
            <p style="width: 72px; height: 40px; display: flex; align-items: center;  justify-content: center; color: #000;">{{printData.completeHakjum}}</p>
            <p style="width: 72px; height: 40px; border-left: 1px solid #000; justify-content: center; align-items: center; display: flex;">{{printData.avgHakjum}}</p>
            <p style="width: 71px; border-left: 1px solid #000; background: #f6f6f6; font-weight: 500; display: flex; justify-content: center; align-items: center;">
              전전학기평점
            </p>
            <p style="width: 73px; border-left: 1px solid #000; display: flex; align-items: center;  justify-content: center; color: #000;">{{printData.prev2AvgHakjum}}</p>
            <p style="width: 72px; border-left: 1px solid #000; background: #f6f6f6; font-weight: 500; display: flex; justify-content: center; align-items: center; border-right: 1px solid #000;">
              전학기평점
            </p>
            <p style="width: 72px; display: flex; align-items: center;  justify-content: center; color: #000;">{{printData.prevAvgHakjum}}</p>
          </li>

          <li style="display: flex; height: 20px;">
            <p style="width: 72px; display: flex; align-items: center;  justify-content: center; color: #000;"></p>
            <p style="width: 72px; border-left: 1px solid #000; display: flex; align-items: center;  justify-content: center; color: #000;"></p>
            <p style="width: 71px; border-left: 1px solid #000; border-top: 1px solid #000; background: #f6f6f6; font-weight: 500; display: flex; justify-content: center; align-items: center;">
              취득학점
            </p>
            <p style="width: 73px; border-left: 1px solid #000; border-top: 1px solid #000; display: flex; align-items: center;  justify-content: center; color: #000;">{{printData.prev2ComplateHakjum}}</p>
            <p style="width: 72px; border-left: 1px solid #000; border-top: 1px solid #000; background: #f6f6f6; font-weight: 500; display: flex; justify-content: center; align-items: center; border-right: 1px solid #000;">
              취득학점
            </p>
            <p style="width: 72px; border-top: 1px solid #000; display: flex; align-items: center;  justify-content: center; color: #000;">{{printData.prevComplateHakjum}}</p>
          </li>
        </ul>
      </div>
      <div style="display: flex; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500;">
          핸드폰
        </p>
        <ul style="border-left: 1px solid #000; flex: 1 1 auto;">
          <li style="display: flex; height: 20px;">
            <p style="display: flex; justify-content: center; align-items: center; width: 144px;">
              {{ printData.phoneNo1 ? printData.phoneNo1 : '' }}
            </p>
            <p style="display: flex; justify-content: center; align-items: center; width: 71px; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500;">비상연락처 1</p>
            <p style="display: flex; justify-content: center; align-items: center; width: 73px; border-left: 1px solid #000;">
              {{ printData.phoneNo3 ? printData.phoneNo3 : '' }}
            </p>
            <p style="display: flex; justify-content: center; align-items: center; width: 71px; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500;">비상연락처 2</p>
            <p style="display: flex; justify-content: center; align-items: center; width: 72px; border-left: 1px solid #000;">
              {{ printData.phoneNo4 ? printData.phoneNo4 : '' }}
            </p>
          </li>
        </ul>
      </div>

      <div style="display: flex; border: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500; text-align: center;">
          학비조달방법
          <br>및
          <br>장학금 수혜경력
        </p>


        <ul style="flex: 1 1 auto;">
          <li style="display: flex; height: 20px;">
            <p style="width: 108px; background: #e0e0e0; font-weight: 500; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; ">
              1학년
            </p>

            <p style="width: 108px; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; display: flex; justify-content: center; align-items: center;">
              2학년
            </p>

            <p style="width: 108px; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; display: flex; justify-content: center; align-items: center;">
              3학년
            </p>

            <p style="width: 108px; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; display: flex; justify-content: center; align-items: center;">
              4학년
            </p>
          </li>

          <li style="display: flex; height: 20px; border-top: 1px solid #000;">
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center;  background: #e0e0e0; font-weight: 500; border-left: 1px solid #000; ">1학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">2학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">1학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">2학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">1학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">2학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">1학기</p>
            <p style="width: 54px; height: 20px; border-bottom: 1px solid #000; display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; background: #e0e0e0; font-weight: 500; ">2학기</p>
          </li>
          

          <li style="display: flex; height: 100px; border-top: 1px solid #000;">
            <template v-for="year in ['1학년', '2학년', '3학년', '4학년']">
              <div style="display: flex; width: 108px; padding-left: 0px;">
                <p
                  v-for="semester in ['1학기', '2학기']"
                  :key="year + '-' + semester"
                  style="width: 54px; height: 100px; border-bottom: 1px solid #000; display: flex; flex-direction: column; align-items: flex-start; padding-right: 1px; border-left: 1px solid #000;"
                >
                  <ul>
                    <li
                      v-for="pattern in ['고대교우회', '교내장학금', '교외장학금']"
                      :key="pattern"
                      v-if="(mappingGotsList.find(item => item.key === `${year}-${semester}-${pattern}`) || {}).totalAmount > 0"
                      style="padding: 2px; margin-bottom: 0px;"
                    >{{ pattern }}<br><span v-text="(() => {
                          const amt = (mappingGotsList.find(item => item.key === `${year}-${semester}-${pattern}`) || {}).totalAmount || 0;
                          if (!amt) return '';
                          return Math.floor(amt / 10000);
                        })()"></span> 만원</li>
                  </ul>
                </p>
              </div>
            </template>
          </li>
        </ul>
      </div>

      <div style="display: flex; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500;">
          재학중 거주상태
        </p>
        <div style="width: 100%; border-left: 1px solid #000; height: 20px; display: flex; padding-left: 10px; align-items: center;">
          {{printData.sHouseGbNm}} <span v-if="printData.sHouseEtc">:{{ printData.sHouseEtc }}</span>
        </div>
      </div>
      <div style="display: flex; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500;">
          현주소
        </p>
        <div style="border-left: 1px solid #000; width: 100%; height: 20px; display: flex; padding-left: 10px; align-items: center;">
          ({{printData.sAddress1}}) {{printData.sAddress2}} {{printData.sAddress3}}
        </div>
      </div>
      <div style="display: flex; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500; text-align: center;">
          E-mail
        </p>
        <div style="border-left: 1px solid #000; width: 100%; height: 20px; display: flex; padding-left: 10px; align-items: center;">
          <p style="width: 206px; display: flex; align-items: center; ">① {{printData.eMail}}</p>
          <p style="height: 20px; display: flex; padding-left: 10px; align-items: center; border-left: 1px solid #000;">② {{printData.eMail2}}</p>
        </div>
      </div>

      <div style="display: flex; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500; text-align: center;">
          가족사항
          <!-- <br>(전체구성원
          <br>모두 기록) -->
        </p>


        <ul style="border-left: 1px solid #000; flex: 1 1 auto;">
          <li style="display: flex; height: 20px; background: #e0e0e0; font-weight: 500; text-align: center;">
            <p style="display: flex; justify-content: center; align-items: center; width: 54px;">관계</p>
            <p style="display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; width: 54px;">성명</p>
            <p style="display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; width: 34px;">연령</p>
            <p style="display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; width: 193px;">직업 및 직위(구체적으로)</p>
            <p style="display: flex; justify-content: center; align-items: center; border-left: 1px solid #000; flex: 1 1 auto;">연소득(원)</p>
          </li>

          <li
    v-for="(item, idx) in (printData.familyList.concat(Array(5).fill({})).slice(0, 5))"
    :key="item.seqNo || 'empty-' + idx"
    style="display: flex; height: 20px; border-top: 1px solid #000;"
  >
    <p style="width: 54px; display: flex; justify-content: center; align-items: center;">{{ item.relation || '' }}</p>
    <p style="width: 54px; border-left: 1px solid #000; display: flex; justify-content: center; align-items: center;">{{ item.nm || '' }}</p>
    <p style="width: 34px; border-left: 1px solid #000; display: flex; justify-content: center; align-items: center;">{{ item.age || '' }}</p>
    <p style="width: 193px; border-left: 1px solid #000; display: flex; justify-content: center; align-items: center;">{{ item.job || '' }}</p>
    <p style="flex: 1 1 auto; border-left: 1px solid #000; display: flex; justify-content: right; align-items: center; padding-right: 20px;">
      {{ item.income ? getCurrency(item.income) + ' 원' : '' }}
    </p>
  </li>
        </ul>
      </div>

      <div style="display: flex; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500;">
          보호자<br>(부모)
        </p>
        <ul style="border-left: 1px solid #000; flex: 1 1 auto;">
          <li style="display: flex; background: #e0e0e0;">
            <p style="width: 54px; display: flex; justify-content: center; align-items: center; font-weight: 500;">교우확인</p>

            <div style="border-left: 1px solid #000; flex: 1 1 auto; padding: 5px 10px;" :style="{ background: String(printData.applyGb) === '2' ? '#FFFFFF' : '#e0e0e0' }">
              <div style="display: flex; align-items: center;">
                <p
                  style="width: 10px; height: 10px; border: 1px solid #000; margin-right: 2px;"
                  :style="{ background: printData.parentSex === 'M' ? '#000' : '#fff' }"
                ></p>
                <p style="margin-left: 6px;">부</p>
                <p style="margin-left: 10px;">/</p>
                <!-- 모 체크박스 -->
                <p
                  style="margin-left: 10px; width: 10px; height: 10px; border: 1px solid #000;"
                  :style="{ background: printData.parentSex === 'F' ? '#000' : '#fff' }"
                ></p>
                <p style="margin-left: 6px;">모</p>
                <p style="margin-left: 50px;">
                  {{ printData.parentCollegeCdNm ? printData.parentCollegeCdNm : '대학' }}
                </p>
                <p style="margin-left: 20px;">{{ printData.parentClassCdNm ? printData.parentClassCdNm : '학과' }}</p>
                
                <p style="margin-left: 20px;">{{ printData.parentMemberHnm }} 교우</p>
              </div>
              <div style="display: flex; align-items: center; margin-top: 5px;">
                <p style="margin-left: 130px;">
                  ( <span style="font-weight: 500;"> 학번 :</span> {{ printData.parentHakbun }} | <span style="font-weight: 500;"> 생일 :</span>{{ printData.parentBirthday }} )
              </p>
              </div>

              <!-- <p style="color: #aaa; margin-top: 5px;">(부모가 교우인 경우에만 기재합니다.)</p> -->
            </div>
          </li>

          <li style="border-top: 1px solid #000; display: flex;">
            <p style="height: 20px; width: 55px; border-right: 1px solid #000; display: flex; justify-content: center; align-items: center; font-weight: 500; background: #e0e0e0;">
              주소
            </p>
            <p style="display: flex; justify-content: center; align-items: center; padding-left: 10px;">
              ({{ printData.address1 }}) {{ printData.address2 }} {{ printData.address3 }}
            </p>
          </li>

          <li style="border-top: 1px solid #000; height: 20px; display: flex;">
            <p style="width: 55px; border-right: 1px solid #000; display: flex; justify-content: center; align-items: center; font-weight: 500; background: #e0e0e0;">
              거주상태
            </p>

            <p style="width: 269px; display: flex; justify-content: left; align-items: center; padding-left: 10px;">
              {{printData.houseGbNm}} &nbsp; <span v-if="printData.houseEtc">: {{ printData.houseEtc }}</span>
            </p>

            <p style="width: 55px; border-left: 1px solid #000; border-right: 1px solid #000; display: flex; justify-content: center; align-items: center; font-weight: 500; background: #e0e0e0;">
              평수
            </p>
            <p style="display: flex; justify-content: center; align-items: center; padding-left: 10px;">{{printData.houseSize}} 평</p>
          </li>
        </ul>
      </div>

      <div style="display: flex; border-left: 1px solid #000; border-right: 1px solid #000; border-top: 1px solid #000;">
        <p style="flex: 0 0 auto; background: #e0e0e0; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 500;">
          학자금지원 소득구간(분위)
        </p>


        <div style="border-left: 1px solid #000; flex: 1 1 auto; height: 20px; display: flex; padding-left: 10px; align-items: center;">
          {{ printData.natIncomeGradeCdNm ? printData.natIncomeGradeCdNm : '없음' }}
        </div>
      </div>
      <!-- <div style="display: flex; border-top: 1px solid #000; background: #FFE6EA;">
        <p style="flex: 0 0 auto; display: flex; justify-content: center; align-items: center; width: 99px; font-weight: 700; text-align: center;">
          학자금지원
          <br>소득구간(분위)통지서
          <br>제출시 미기재
        </p>
        <ul style="flex: 1 1 auto; border-left: 1px solid #000;">
          <li style="display: flex; height: 20px;">
            <p style="width: 81px; font-weight: 500; display: flex; justify-content: center; align-items: center;">건강보험료 납부액</p>
            <div style="border-left: 1px solid #000; padding-left: 10px; display: flex; align-items: center; width: 110px; justify-content: space-between;">
              <span>(</span>)원/월
            </div>
            <p style="margin-left: 6px; color: #aaa; display: flex; justify-content: center; align-items: center;">(최종납부월 금액명기)</p>
          </li>
          <li style="display: flex; height: 20px; border-top: 1px solid #000;">
            <p style="width: 265px; font-weight: 500; display: flex; justify-content: center; align-items: center;">연간 재산세 과세 총계(첨부서류중 부/모 재산세 과세증명서 합계 금액 명기)</p>
            <div style="border-left: 1px solid #000; padding-left: 10px; display: flex; align-items: center; width: 100px; justify-content: space-between;">
              <span>(</span>)원
            </div>
          </li>
        </ul>
      </div> -->
      <div style="border: 1px solid #000; padding: 10px 10px 10px;">
        <ul>
          <!-- <li style="display: flex;">
            <p style="font-size: 7px;">1.</p>
            <div style="font-size: 7px; margin-left: 3px;">
              위 개인정보의 이용목적은 장학급의 심사 및 지급이며 보존의 필요가 없는 한 처리목적 달성 후 지체 없이 파기합니다. 단, 처리목적과 관련된 민원처리,
              <br>법령상 의무이행을 위하여 필요한 범위 내에서는 보유 이용됩니다.
            </div>
          </li> -->
          <li style="display: flex; margin-top: 2px;">
            <!-- <p style="font-size: 7px;">2.</p> -->
            <div style="font-size: 7px; margin-left: 3px;">
              본인은 개인정보 수집·이용 및 장학금 운영규정에 동의를 하였으며, 위 기재한 내용은 사실과 다름이 없음을 확인합니다.
            </div>
          </li>
        </ul>
        <div style="margin-top: 10px; padding-right: 13px; display: flex; align-items: center; justify-content: flex-end; gap: 34px;">
          <p>{{ getDatePart(printData.insertDate, 'year') }}년</p>
          <p>{{ getDatePart(printData.insertDate, 'month') }}월</p>
          <p>{{ getDatePart(printData.insertDate, 'day') }}일</p>
        </div>
        <!-- <div style="margin-top: 12px; padding-right: 13px; display: flex; align-items: center; justify-content: flex-end;">
          <div style="width: 165px; display: flex; justify-content: space-between;">
            <p>성명 :</p>
            <p>(인/서명)</p>
          </div>
        </div> -->
      </div>
  </div><!-- .wrap end -->
  <!-- 자기소개서 -->
<div class="wrap" style="width: 595px; padding: 10px 30px 30px; background: #fff;">
  <p style="text-align: center; font-size: 18px; font-weight: 700;">자 기 소 개 서</p>
  
  <!-- <hr style="width: 100%; height: 0.5px; background: #000; border: 0; margin: 10px 0;"> -->
  
  <!-- <ul style="font-size: 10px; text-align: left;">
    <li style="line-height: 10px;">· <strong>자기소개서</strong> 글자는 10~11포인트, 최소 800자~최대 3,000자에 맞게 작성하십시오.</li>
    <li style="line-height: 10px;">· <strong>신청사유, 가정형편, 등록금 조달 방법, 향후학업계획 및 학업진로를 상세하게 기술 하십시오.</strong></li>
  </ul> -->
  
<div
  v-for="(pageText, idx) in selfIntroPages"
  :key="idx"
  :style="`
    font-size: 9pt; letter-spacing: 0; line-height: 150%; border: 1px solid #000;
    padding: 10px 10px; white-space: pre-wrap; word-break: normal; margin-top: 10px; width: 100%;
    text-align: left; display: block;
    ${idx !== selfIntroPages.length - 1 ? 'page-break-after: always;' : ''}
  `"
>
  {{ pageText }}
</div>
</div><!-- 자기소개서 end -->
</div>
    </template>
  </modal>
</template>

<script>
import html2pdf from 'html2pdf.js'
import URL_CONST from "@/kuaa/kuaa-url-const";
import Modal from "@/components/Modal.vue";

export default {
  name: "PrintableApplicant",

  components: {
    Modal,
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    },
  printData: {
    type: Object,
    default: () => ({})
  }
  },

  data() {
    return {
      mappingGotsList: null,   // key : 'got.year+got.semesterCd, value:[{schShipCd1: , amount: ...}]
      downloadUrl: URL_CONST.FILE_DOWN_LOAD_HP,
      dummyLines: [],
      selfIntroPages: []
    }
  },

  watch: {
  isShow(newVal) {
    if (newVal && this.printData && Object.keys(this.printData).length > 0) {
      this.setPrintData(this.printData);
    }
  },
  printData: {
    handler(newVal) {
      if (this.isShow && newVal && Object.keys(newVal).length > 0) {
        this.setPrintData(newVal);
      }
    },
    immediate: true,
    deep: true
  }
},

  methods: {
  splitSelfIntroByRenderedHeight(text, pageHeightPxArr = [740, 775]) {
    // dummyLines는 더이상 split하지 않고, 전체 텍스트를 넣음
    this.dummyLines = [text];

    this.$nextTick(() => {
      const dummy = this.$refs.dummySelfIntro;
      // 문장 단위로 split (마침표, 물음표, 느낌표, 줄바꿈)
      // 줄바꿈만 있는 경우도 포함
      const sentenceRegex = /([^.!?\n]+[.!?]?|\n)/g;
      let sentences = [];
      let match;
      while ((match = sentenceRegex.exec(text)) !== null) {
        // 줄바꿈만 있는 경우는 그대로 추가
        if (match[0] === '\n') {
          sentences.push('\n');
        } else {
          sentences.push(match[0].trim());
        }
      }
      let pages = [];
      let currText = '';
      let currHeight = 0;
      let pageIdx = 1;
      let pageHeightPx = Array.isArray(pageHeightPxArr) ? pageHeightPxArr[0] : pageHeightPxArr;

      for (let i = 0; i < sentences.length; i++) {
        let nextText;
        if (sentences[i] === '\n') {
          nextText = currText + '\n';
        } else {
          nextText = currText ? currText + ' ' + sentences[i] : sentences[i];
        }
        dummy.innerText = nextText;
        currHeight = dummy.offsetHeight;
        if (currHeight > pageHeightPx) {
          if (currText) pages.push(currText);
          currText = sentences[i] === '\n' ? '\n' : sentences[i];
          pageIdx++;
          pageHeightPx = Array.isArray(pageHeightPxArr)
            ? (pageHeightPxArr[1] || pageHeightPxArr[pageHeightPxArr.length - 1])
            : pageHeightPxArr;
        } else {
          currText = nextText;
        }
      }
      if (currText) pages.push(currText);
      this.selfIntroPages = pages;
    });
  },
    async setPrintData(data) {
  this.printData = data;
  const gotsList = Array.isArray(this.printData.gotsList) ? this.printData.gotsList : [];

  // 1. 'schYear-schSemester-schShipNm2'를 key로 합계 저장
const sumMap = {};

const yearMap = { '01': '1학년', '02': '2학년', '03': '3학년', '04': '4학년' };
gotsList.forEach(item => {
  const year = yearMap[item.schYear] || item.schYear;
  const semester = item.schSemester; // 예: "1학기"
  const schShipNm5 = item.schShipNm ? item.schShipNm.substr(0, 5) : '';
  const key = `${year}-${semester}-${schShipNm5}`;
  if (!sumMap[key]) sumMap[key] = 0;
  sumMap[key] += Number(item.amount) || 0;
});

// 2. 모든 학년/학기/장학명5글자 조합 추출 (중복 없이 정렬)
const yearSet = new Set(gotsList.map(item => yearMap[item.schYear] || item.schYear));
const semesterSet = new Set(gotsList.map(item => item.schSemester));
const schShipNm5Set = new Set(gotsList.map(item => item.schShipNm ? item.schShipNm.substr(0, 5) : ''));
const years = Array.from(yearSet).sort((a, b) => a.localeCompare(b, 'ko-KR', {numeric: true}));
const semesters = Array.from(semesterSet).sort((a, b) => a.localeCompare(b, 'ko-KR', {numeric: true}));
const schShipNm5s = Array.from(schShipNm5Set).sort();

// 3. 결과 배열 생성 (누락된 조합도 0으로)
const result = [];
years.forEach(year => {
  semesters.forEach(semester => {
    schShipNm5s.forEach(schShipNm5 => {
      const key = `${year}-${semester}-${schShipNm5}`;
      result.push({
        key,
        year,
        semester,
        schShipNm5,
        totalAmount: sumMap[key] || 0
      });
    });
  });
});

this.mappingGotsList = result;
// console.log('[PrintableApplicant] gotsList 원본:', gotsList.map(i => ({ schYear: i.schYear, schSemester: i.schSemester, schShipNm: i.schShipNm, schShipNm5: i.schShipNm ? i.schShipNm.substr(0,5) : '', amount: i.amount })));
// console.log('[PrintableApplicant] mappingGotsList (totalAmount>0):', result.filter(r => r.totalAmount > 0));
this.splitSelfIntroByRenderedHeight(this.printData.selfIntroduction);
},

    async exportToPDF () {
      await html2pdf(this.$refs.pdfArea, {
        margin: [6, 5],
        filename: this.printData.nm+'_장학금신청서.pdf',
        image: {type:"jpg", quality: 0.95},
        html2canvas: {useCORS: true, scrollY: 0, scale:2, dpi: 300, letterRendering: true, allowTaint: false},
        jsPDF: {orientation: 'portrait', unit: 'px', format: [595, 842], compressPDF: false},
        pagebreak: { mode: ['css', 'legacy'] } // ★ 페이지 분할 옵션

      });
      // PDF 저장 후에만 데이터 초기화 및 모달 닫기
      this.mappingGotsList = null;
      this.printData = {};
      this.$emit('update:isShow', false);
    },

    getCurrency(num) {
      return num ? num.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,') : 0;
    },
    getDatePart(timestamp, part) {
      if (!timestamp) return '';
      const date = new Date(Number(timestamp));
      if (isNaN(date.getTime())) return '';
      switch(part) {
        case 'year':
          return date.getFullYear();
        case 'month':
          return String(date.getMonth() + 1).padStart(2, '0');
        case 'day':
          return String(date.getDate()).padStart(2, '0');
        default:
          return '';
      }
    },
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        if (!map.has(key)) {
          map.set(key, [item]);
        } else {
          map.get(key).push(item);
        }
      });
      return map;
    }

  }
}
</script>

<style>
  .wrap * { margin: 0; padding: 0; list-style: none; font-family: "Noto Sans KR", sans-serif; color: #000; font-size: 8px; line-height: normal; }
  .modal {
  max-height: 90vh;
  overflow-y: auto;
}
</style>